import { useTRPCAPI, useTRPCQuery } from '../../../../trpc/trpc';
import { useUserTokenDecoded } from '../../../../redux/slices/appInfo/hooks';
import { useIsDemoAccount } from '../../../accountSelector/useIsDemoAccount';
import { useIsNativeEmbed } from '../../navigation/hooks/useIsNativeEmbed';
import { useAiNudgeDismissed } from './useAiNudgeDismissed';

/**
 * Whether the artist Home shows the AI assistants card (design: ai-assistants n6). All of this
 * must be true: a signed-in user who did not close the card, not the demo artist, not the native
 * web view, and `oauthClients.list` answered with no connected assistant. While the call is
 * pending, and when it fails (an API or OAuth token gets FORBIDDEN), the card does not show.
 */
export function useAiNudge(): { isVisible: boolean; dismiss: () => void } {
  const trpcAPI = useTRPCAPI();
  const userId = useUserTokenDecoded()?.id ?? null;
  const isDemo = useIsDemoAccount();
  const isNative = useIsNativeEmbed();
  const { isDismissed, dismiss } = useAiNudgeDismissed(userId);

  const canAsk = userId !== null && !isDemo && !isNative && !isDismissed;
  // The same query as Settings → AI assistants, so a new or a revoked assistant shows here too.
  const { data, isSuccess } = useTRPCQuery(
    trpcAPI.oauthClients.list.queryOptions(undefined, { retry: false, enabled: canAsk })
  );

  return { isVisible: canAsk && isSuccess && Array.isArray(data) && data.length === 0, dismiss };
}
